import React, { useState, useEffect } from 'react';
import { renderToString } from 'react-dom/server';
import { useIntl, history } from 'umi';
import { useRequest } from 'ahooks';
import { Modal } from 'tea-component';
import Abnormal from '@/pages/intelligence/components/Abnormal';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import ExpandCollapseText from '@/pages/intelligence/components/ExpandCollapse';
import MoreModal from '../../../../../MoreModal';
import { fetchCompanyDetailsSummaryNews } from '@/pages/intelligence/services/companies';
import { getCompanyDetailsPath } from '@/pages/intelligence/utils/topchartsUtils';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { COMBINEID_REG } from '@intelligence/utils/constant';
import type { ICompaniesDetailsPageBaseProps } from '../../../types';

import './index.scss';

const RecentNewsActivity: React.FC<ICompaniesDetailsPageBaseProps> = (props) => {
  const { companyId } = props;

  const { loading, data, run } = useRequest(fetchCompanyDetailsSummaryNews, { manual: true });

  const companyNews = data?.companyNews;

  const { formatMessage } = useIntl();

  const [detailsVisible, setDetailsVisible] = useState(false);
  const [originalNewsVisible, setOriginalNewsVisible] = useState(false);
  const [currentData, setCurrentData] = useState<any>({});

  const goToNewsActivityPage = () => {
    const path = getCompanyDetailsPath({ companyId, tab: 'NewsActivity' });
    history.push(path);
  };

  useEffect(() => {
    if (!companyId) return;
    if (!COMBINEID_REG.test(companyId)) return; // 添加ID校验规则
    run({ company_id: companyId });
  }, [companyId]);

  const shareIcon = (
    <SvgIcon
      type="other-share-icon"
      onClick={(e) => {
        e?.stopPropagation();
        e?.preventDefault();
        setOriginalNewsVisible(true);
      }}
    />
  );

  return (
    <CardSlot
      className="context-card"
      title={formatMessage({ id: 'dbi_company_recent_news_activity' })}
      isAction={true}
      iconList={[]}
      getDetails={goToNewsActivityPage}
    >
      <Abnormal
        isLoading={loading}
        isNoData={!loading && !companyNews?.length}
        component={
          <div className="dbi-activity">
            {companyNews?.slice(0, 3)?.map((item: any) => (
              //  <SvgIcon type="other-share-icon" /> 两个 是判断是否紧跟后面的icon
              <div
                key={item?.uuidMd5}
                className="dbi-activity-item"
                onClick={() => {
                  const currentDataTmp = {
                    title: item?.title,
                    title_en: item?.titleEn,
                    title_cn: item?.titleCn,
                    content: item?.news,
                    content_en: item?.news,
                    content_cn: item?.news,
                    news_type: item?.newsType,
                    url: item?.url,
                    posted_on: item?.postedOn,
                  };
                  setCurrentData(currentDataTmp);
                  setDetailsVisible(true);
                }}
              >
                <ExpandCollapseText
                  text={renderToString(
                    <>
                      {item?.news}
                      <span className="dbi-activity-item-icon">{shareIcon}</span>
                    </>,
                  )}
                  onClick={(e: any) => {
                    e?.stopPropagation();
                    e?.preventDefault();
                    setDetailsVisible(true);
                  }}
                  otherText={
                    <div className="dbi-activity-item-text">
                      <span className="dbi-activity-item-icon dbi-mr">{shareIcon}</span>
                      {formatMessage({ id: 'dbi_more' })}
                    </div>
                  }
                />
                <div className="dbi-activity-context">
                  <span className="text-desc">{item?.newsType}</span>
                  <span className="text-time">{item?.postedOn}</span>
                </div>
              </div>
            ))}
          </div>
        }
      />
      <MoreModal
        lang="original"
        title={formatMessage({ id: 'dbi_company_media_news' })}
        data={currentData}
        visible={detailsVisible}
        close={() => setDetailsVisible(false)}
      />
      <Modal
        className="media-modal"
        size={500}
        visible={originalNewsVisible}
        onClose={() => setOriginalNewsVisible(false)}
      >
        <Modal.Body>
          <div className="media-modal-title">
            {formatMessage({ id: 'dbi_company_original_news' })}
          </div>
          <a className="media-modal-link" href={currentData?.url} target="_blank" rel="noreferrer">
            {currentData?.url}
          </a>
        </Modal.Body>
      </Modal>
    </CardSlot>
  );
};

export default RecentNewsActivity;
